<div class="input-container">
  <input class="form-control"
         type="text"
         placeholder="Personal Property Assessment Number"
         [id]="control().element.id"
         [formControl]="control().AsTyped"
         [class]="formHelper.getValidIndicator(control())" >
  @if (isValidating) {
    <span class="spinner-icon"
          #loadingTooltip="ngbTooltip"
          ngbTooltip="Validating Input"
          triggers=""
          [autoClose]="'none'"
          placement="bottom">
      <i class="fas fa-spinner fa-spin"></i>
    </span>
  }
</div>

@if (isValidating) {
  <i class="fas fa-spinner fa-spin"></i> <em style="padding-left: 5px">Validating the assessment, please wait.</em>
}
